import { TFunction } from "next-i18next";
import { IUserReactionBarConfig, TUserReactionBarOptions } from "src/components/user-reactions/types";

export const getSurprisedReactionBarOptions = (t: TFunction): TUserReactionBarOptions => [
    {
        backgroundColor: "blue.600",
        text: t("user-reaction-bar.legend-hardly", { ns: "reactions" }),
        value: 1,
    },
    {
        backgroundColor: "blue.600",
        value: 2,
    },
    {
        backgroundColor: "blue.600",
        value: 3,
    },
    {
        backgroundColor: "blue.600",
        value: 4,
    },
    {
        backgroundColor: "blue.600",
        text: t("user-reaction-bar.legend-very", { ns: "reactions" }),
        value: 5,
    },
];

export const getMarketOverreactionReactionBarOptions = (t: TFunction): TUserReactionBarOptions => [
    {
        backgroundColor: "yellow.600",
        text: t("user-reaction-bar.legend-hardly", { ns: "reactions" }),
        value: 1,
    },
    {
        backgroundColor: "yellow.600",
        value: 2,
    },
    {
        backgroundColor: "yellow.600",
        value: 3,
    },
    {
        backgroundColor: "yellow.600",
        value: 4,
    },
    {
        backgroundColor: "yellow.600",
        text: t("user-reaction-bar.legend-very", { ns: "reactions" }),
        value: 5,
    },
];

export const getUnderlyingPricePredictionReactionBarOptions = (): TUserReactionBarOptions => [
    {
        backgroundColor: "red.600",
        text: "< -30%",
        value: -2,
    },
    {
        backgroundColor: "red.600",
        text: "< -15%",
        value: -1,
    },
    {
        backgroundColor: "gray.400",
        text: "neutral",
        value: 0,
    },
    {
        backgroundColor: "green.600",
        text: "> +15%",
        value: 1,
    },
    {
        backgroundColor: "green.600",
        text: "> +30%",
        value: 2,
    },
];

export const getSurprisedReactionBarConfig = (t: TFunction): IUserReactionBarConfig => ({
    label: t("user-reaction-bar.surprise-question", { ns: "reactions" }),
    options: getSurprisedReactionBarOptions(t),
});

export const getMarketOverreactionReactionBarConfig = (t: TFunction): IUserReactionBarConfig => ({
    label: t("user-reaction-bar.overreaction-question", { ns: "reactions" }),
    options: getMarketOverreactionReactionBarOptions(t),
});

export const getUnderlyingPricePredictionReactionBarConfig = (t: TFunction): IUserReactionBarConfig => ({
    label: t("user-reaction-bar.price-potential-question", { ns: "reactions" }),
    options: getUnderlyingPricePredictionReactionBarOptions(),
});
